const ValidateFiveDigitCode = postcode => {
    let codePattern =   /^\d{5}$/ ;
    return codePattern.test(postcode);
};
const ValidateNineDigitCode = postcode => {
    let codePattern = /^\d{ 5}$|^\d{ 5 } -\d{ 4 } $ /;
    return codePattern.test(postcode);
};

export{
    ValidateFiveDigitCode,
    ValidateNineDigitCode
};